/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPricesFilters {
  /** Тип комнатности (Студия, 1/2/3/4+ комнатные) **/
  roomCount: ERoomCount;
  /** Тип оценки (за объект/за м²) **/
  pricesType: EPricesType;
  /** Временной интервал для оценки (полгода/год/всё время) **/
  period: EPeriod;
}

export enum ERoomCount {
  /** Студия **/
  'Studio' = 'studio',
  /** Однокомнатная квартира **/
  'OneRoom' = 'oneRoom',
  /** Двухкомнатная квартира **/
  'TwoRoom' = 'twoRoom',
  /** Трехкомнатная квартира **/
  'ThreeRoom' = 'threeRoom',
  /** Четырехкомнатная квартира **/
  'FourRoom' = 'fourRoom',
}
export enum EPricesType {
  /** Цена за объект **/
  'Price' = 'price',
  /** Цена за м² **/
  'PriceSqm' = 'priceSqm',
}
export enum EPeriod {
  /** За полгода **/
  'HalfYear' = 'halfYear',
  /** За год **/
  'Year' = 'year',
  /** За всё время **/
  'AllTime' = 'allTime',
}
